import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import PaymentOptionCard from '../components/payment-option-card'
import Footer from '../components/footer'
import './payment-methods.css'

const PaymentMethods = (props) => {
  return (
    <div className="payment-methods-container1">
      <Helmet>
        <title>PaymentMethods - Copy of iCharge web copy 2</title>
        <meta
          property="og:title"
          content="PaymentMethods - Copy of iCharge web copy 2"
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/d8d38ac4-4f3e-47be-9087-cfeb299d0f93/a5b67eda-b5fa-4da5-98e7-80a54823e21a?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Navbar
        homeLink1={
          <Fragment>
            <span className="payment-methods-text10">
              View real-time charger availability, monitor your charging
              sessions, and more
            </span>
          </Fragment>
        }
        homeLink2={
          <Fragment>
            <span className="payment-methods-text11">
              Discover one of the nation&apos;s largest public fast charging
              networks, powered by 100% renewable energy
            </span>
          </Fragment>
        }
        homeLink3={
          <Fragment>
            <span className="payment-methods-text12">How to Charge</span>
          </Fragment>
        }
        homeLink4={
          <Fragment>
            <span className="payment-methods-text13">
              Learn how to power up on the go and review our charging FAQs.
            </span>
          </Fragment>
        }
        homeLink5={
          <Fragment>
            <span className="payment-methods-text14">
              Can&apos;t find what you&apos;re looking for? Let us help you.
            </span>
          </Fragment>
        }
        aboutLink1={
          <Fragment>
            <span className="payment-methods-text15">
              From recycling to renewable energy, we&apos;re committed to
              protecting our environment.
            </span>
          </Fragment>
        }
        aboutLink2={
          <Fragment>
            <span className="payment-methods-text16">
              Cultivating Connection
            </span>
          </Fragment>
        }
        supportLink1={
          <Fragment>
            <span className="payment-methods-text17">
              <span>
                Whether you&apos;re a dedicated public charger or want to keep
                your options open,
              </span>
              <br></br>
              <span> iCharge has a plan for you.</span>
            </span>
          </Fragment>
        }
        supportLink2={
          <Fragment>
            <span className="payment-methods-text21">How to charge</span>
          </Fragment>
        }
        rootClassName="navbarroot-class-name12"
        chargingPointLink1={
          <Fragment>
            <span className="payment-methods-text22">
              Can&apos;t find what you&apos;re looking for? Let us help you
            </span>
          </Fragment>
        }
        chargingPointLink2={
          <Fragment>
            <span className="payment-methods-text23">
              Locate nearby charging points with the iCharge app and simplify
              your charging
            </span>
          </Fragment>
        }
      ></Navbar>
      <section className="payment-methods-services column align-center justify-center full-width thq-section-padding">
        <div className="payment-methods-max-width column align-center full-width max-content-width">
          <div className="payment-methods-header column align-center gap-2-5">
            <div className="row">
              <h2 className="payment-methods-text24 heading-1">
                iCharge Payment Options
              </h2>
            </div>
          </div>
          <div className="payment-methods-cards-container full-width">
            <PaymentOptionCard
              heading={
                <Fragment>
                  <span className="payment-methods-text25">
                    <span>
                      Credit Card Payment
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <span>via the App</span>
                  </span>
                </Fragment>
              }
              imageSrc="/Pages/card%20element-1500h.webp"
              rootClassName="payment-option-cardroot-class-name"
            ></PaymentOptionCard>
            <PaymentOptionCard
              heading={
                <Fragment>
                  <span className="payment-methods-text29">
                    <span>Pay Cash Through</span>
                    <br></br>
                    <span>Western Union</span>
                    <br></br>
                  </span>
                </Fragment>
              }
              rootClassName="payment-option-cardroot-class-name2"
            ></PaymentOptionCard>
            <PaymentOptionCard
              heading={
                <Fragment>
                  <span className="payment-methods-text34">
                    <span>Balance Top-Up with</span>
                    <br></br>
                    <span>Voucher</span>
                    <br></br>
                  </span>
                </Fragment>
              }
              imageSrc="/cupon%20element.svg"
              rootClassName="payment-option-cardroot-class-name1"
            ></PaymentOptionCard>
          </div>
        </div>
      </section>
      <Footer rootClassName="footerroot-class-name16"></Footer>
    </div>
  )
}

export default PaymentMethods
